module.exports = __webpack_public_path__ + "img/intro.913acdf1.jpg";